import { Stack, Typography, Box } from "@mui/material";
import React from "react";

const AudioView = ({ item, index }) => {
  const audioSrc =
    item?.audioUrl ||
    item?.answers?.[0] ||
    item?.filesAnswers?.[0]?.serverPath ||
    item?.filesAnswers?.[0]?.localPath;

  return (
    <>
      <Stack>
        <Typography>
          <span
            style={{
              color: "black",
              fontSize: "18px",
            }}
          >
            {index}.{" "}
          </span>
          {item?.question}
        </Typography>
        <Stack direction="column" spacing={1} sx={{ ml: 3, mt: 1 }}>
          {audioSrc && (
            <Box>
              <audio controls src={audioSrc}>
                Your browser does not support the audio element.
              </audio>
            </Box>
          )}
          {item?.answer && (
            <Typography variant="body1" sx={{ color: "black" }}>
              {item.answer}
            </Typography>
          )}
          {!audioSrc && !item?.answer && (
            <Typography variant="body2" color="textSecondary">
              No Answer Given
            </Typography>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default AudioView;

